/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const permissionsOutputDataRoleSchema = z.enum(['member', 'admin', 'jobillan', 'recruiter'])

export type PermissionsOutputDataRoleSchema = z.infer<typeof permissionsOutputDataRoleSchema>
